import Testimonial from "./testimonial/testimonial"
import demoUserImage from "../../../assets/images/testimonial/demo-user.png";
import AnthonyKingImage from "../../../assets/images/testimonial/Anthony-King-Right-Choice-150x150.jpg";
import WayneImage from "../../../assets/images/testimonial/Brad-Wearne-Meridian-297x300.jpg";
import BradImage from "../../../assets/images/testimonial/Wayne-Danckert-Express-Property-300x300.jpg";

import RightChoiceLogo from "../../../assets/images/testimonial/Right-Choice-Real-Estate.png";
import MeridianLogo from "../../../assets/images/testimonial/Meridian-150x150.png";
import ExpressLogo from "../../../assets/images/testimonial/Express-Property.png";

const TestimonialSection = (props) => {
    return ( 
        <section id="testimonial" style={{backgroundColor:"var(--bs-gray-300)"}}>
            <div className="container-xl" style={{ padding: "4rem 1rem" }}>
                <h1 className="text-center text-secondary">Testimonials</h1>
                <div className="container-fluid">
                    <div className="row row-cols-1 row-cols-md-1 row-cols-lg-3" style={{marginTop:"4rem","--bs-gutter-y": "7rem"}}>
                        <div className="col-md d-flex justify-content-center">
                            <Testimonial logoSize="50px" imgMargin="15px" img={BradImage} logo={ExpressLogo} name="Wayne Danckert" role="Express Property" location="North West Sydney" content="It’s simple, easy and affordable"/>
                        </div>
                        <div className="col-md d-flex justify-content-center">
                            <Testimonial img={WayneImage} logo={MeridianLogo} name="Brad Wearne" role="Meridian Australia" location="Surry Hills" content="I no longer stress about compliance. It’s all in one convenient spot"/>
                        </div>
                        <div className="col-md d-flex justify-content-center">
                            <Testimonial img={AnthonyKingImage} logo={RightChoiceLogo} name="Anthony King" role="Right Choice Real Estate" location="Albion Park" content="I just follow the easy instructions, nothing gets missed"/>
                        </div>
                    </div>
                </div>
            </div>
        </section> 
    );
}
 
export default TestimonialSection;